export default __webpack_public_path__ + "static/2252-5bba310e3bc43cb1f4f4bbc8c264e932.gif";